import { AxiosError } from "axios";
import { useMutation, useQuery } from "react-query";
import { pm2Service } from "../services/pm2";
import { PM2Process } from "../types/pm2";

export const usePm2 = () => {
  const processes = useQuery<PM2Process[], Error>(["pm2-processes"], () =>
    pm2Service.listProcesses().then((res) => res.data),
  );

  const restart = useMutation({
    mutationFn: pm2Service.restartApp,
    onError: (error: AxiosError) => {
      if (error.response?.status === 403) {
        alert("Apenas desenvolvedores podem reiniciar processos");
      }
    },
  });

  const stop = useMutation({
    mutationFn: pm2Service.stopApp,
    onError: (error: AxiosError) => {
      if (error.response?.status === 403) {
        alert("Apenas desenvolvedores podem parar processos");
      }
    },
  });

  const logs = useMutation({
    mutationFn: pm2Service.getLogs,
    onError: (error: AxiosError) => {
      if (error.response?.status === 403) {
        alert("Apenas desenvolvedores podem visualizar logs");
      }
    },
  });

  const isUnauthorized =
    processes.error?.message === "unauthorized" ||
    restart.error?.message === "unauthorized" ||
    stop.error?.message === "unauthorized" ||
    logs.error?.message === "unauthorized";

  return {
    processes,
    restart,
    stop,
    logs,
    isUnauthorized,
  };
};
